import React from 'react'

import useDebounce from '../../../../commons/src/hooks/use-debounce'
import cn from '../../../../commons/src/libs/class-names'

import LoadingIndicator from '../../../../commons/src/components/loading-indicator'
import Paragraph from '../../../../commons/src/components/paragraph'

export interface Props {
  classNames?: string[]
  delay?: number
  loading?: boolean
  description?: React.ReactNode
}

const ContentLoader = ({classNames, delay = 500, loading = false, description}: Props) => {
  const debouncedLoading = useDebounce(loading, delay, false)

  return (
    <div className={cn('ContentLoader', {loading: debouncedLoading && loading}, classNames)}>
      <LoadingIndicator />
      {description && <Paragraph minor>{description}</Paragraph>}
    </div>
  )
}

export default ContentLoader
